import cidRepository from './cidRepository'
import classificacaoRepository from './classificacaoRepository'
import financiamentoRepository from './financiamentoRepository'
import ocupacaoRepository from './ocupacaoRepository'
import procedimentoRepository from './procedimentoRepository'
import procedimentoValidacoesRepository from './procedimentoValidacoesRepository'
import servicoRepository from './servicoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/sigtap`

    return {
        cid: cidRepository(baseUrl),
        classificacao: classificacaoRepository(baseUrl),
        financiamento: financiamentoRepository(baseUrl),
        ocupacao: ocupacaoRepository(baseUrl),
        procedimento: procedimentoRepository(baseUrl),
        procedimentoOcupacao: procedimentoValidacoesRepository(baseUrl),
        servico: servicoRepository(baseUrl),
    }
}